/* Common Imports */

import { styled } from "@mui/system";
import React from "react";

/* Redux Imports */

import { ShowContactDetailsPropertyThunk } from "../../../../../redux-magic/thunks";

/* Components Imports */

import { CircularProgress, Skeleton, Switch, Typography } from "@mui/material";
import { useRouter } from "next/router";

/* Styled Components */

const MainContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
	height: "100%",
	gap: "0.5rem",
	padding: "1rem 1rem 1rem 1rem",
	background: theme.palette.background.paper,
	borderRadius: "16px",
}));

const Heading = styled(Typography)(({ theme }) => ({
	margin: "0.5rem 0rem 0.5rem 0rem",
	width: "100%",
	fontWeight: "500",
	fontSize: "1rem",
	[theme.breakpoints.up("sm")]: {
		fontSize: "1rem",
	},
	[theme.breakpoints.up("md1190")]: {
		fontSize: "1.125rem",
	},
}));

const SwitchContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
}));

const ShowContactDetails = ({
	dispatch,
	session,
	loading,
	propertyData,
}: {
	propertyData: any;
	dispatch: any;
	session: any;
	loading: boolean;
}) => {
	const router = useRouter();

	const [switchLoading, setSwitchLoading] = React.useState<boolean>(false);

	const handleChange = async (event: any) => {
		setSwitchLoading(true);
		await dispatch(
			ShowContactDetailsPropertyThunk({
				property_id: propertyData._id,
				show_contact_details: event.target.checked,
				sessionId: session ? (session.session_id ? session.session_id : "") : "",
			}),
		);
		setSwitchLoading(false);
	};

	if (loading) {
		return (
			<MainContainer>
				<Heading>
					<Skeleton
						animation="wave"
						variant="text"
						width="15rem"
					/>
				</Heading>
				<SwitchContainer>
					<Typography variant="body2">
						<Skeleton
							animation="wave"
							variant="text"
							width="15rem"
						/>
					</Typography>
				</SwitchContainer>
			</MainContainer>
		);
	}

	return (
		<React.Fragment>
			<MainContainer>
				<Heading>{router.locale === "ar-AE" ? "إذن الاتصال" : "Show contact details"}</Heading>
				<SwitchContainer>
					<Typography variant="body2">
						{router.locale === "ar-AE"
							? "السماح للمستخدمين الآخرين برؤية تفاصيل الاتصال الخاصة بك"
							: "Allow other users to see your contact details"}
					</Typography>
					{switchLoading ? (
						<CircularProgress />
					) : (
						<Switch
							id="spp_show_contact_switch"
							checked={propertyData.show_contact_details}
							onChange={handleChange}
						/>
					)}
				</SwitchContainer>
			</MainContainer>
		</React.Fragment>
	);
};

export default ShowContactDetails;
